import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ContactPopup from "./ContactPopup";
import MobileNavigation from "./MobileNavigation";

export default function Header() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setOpenDropdown(null);
  }, [location.pathname]);

  const dropdownProps = (name) => ({
    onMouseEnter: () => setOpenDropdown(name),
    onMouseLeave: () => setOpenDropdown(null),
    onFocus: () => setOpenDropdown(name),
    onBlur: (event) => {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        setOpenDropdown(null);
      }
    },
  });

  useEffect(() => {
  const handleScroll = () => {
    const header = document.querySelector(".header-area");
    if (window.scrollY > 50) {
      header.classList.add("stick");
    } else {
      header.classList.remove("stick");
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  return (
    <>
    <header className="header-area white-area">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-5 col-lg-4 col-md-6">
                    <div className="logo">
                        <Link to="/">
                            <img src="/assets/images/logo.webp" alt="Logo" />
                        </Link>
                    </div>
                </div>
                <div className="col-7 col-lg-8 col-md-6">
                    <div className="main-menu">
                        <ul className="list-inline">
                            <li
                              className={`menu-item has-dropdown ${openDropdown === "about" ? "dropdown-open" : ""}`}
                              {...dropdownProps("about")}>
                                <Link to="/about-us" onClick={() => setOpenDropdown(null)}>About</Link>
                                <ul className="dropdown-menu-list">
                                    <li><Link to="/about-us" onClick={() => setOpenDropdown(null)}>Catalyze</Link></li>
                                    <li><Link to="/founder" onClick={() => setOpenDropdown(null)}>Founder</Link></li>
                                </ul>
                            </li>
                            <li
                                className={`menu-item has-dropdown ${openDropdown === "programs" ? "dropdown-open" : ""}`}
                                {...dropdownProps("programs")}
                              >
                                <Link to="/programs" onClick={() => setOpenDropdown(null)}>Programs</Link>
                                <ul className="dropdown-menu-list">
                                  <li><Link to="/institution" onClick={() => setOpenDropdown(null)}>Institution</Link></li>
                                  
                                </ul>
                              </li>
                              <li
                                className={`menu-item has-dropdown ${openDropdown === "teambuilding" ? "dropdown-open" : ""}`}
                                {...dropdownProps("teambuilding")}
                              >
                                <Link onClick={() => setOpenDropdown(null)}>Team Building</Link>
                                <ul className="dropdown-menu-list">
                                  <li><Link to="/corporate-team-building" onClick={() => setOpenDropdown(null)}>Corporate Team Building</Link></li>
                                  <li><Link to="/campus-team-building" onClick={() => setOpenDropdown(null)}>Campus Team Building</Link></li>
                                  
                                </ul>
                              </li>
                            <li><Link to="/blogs">Blogs</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                        <div className="rightmenu-link">
                            <button type="button" className="default-btn" onClick={() => setIsPopupOpen(true)}>Book a Consultation</button>
                        </div>
                    </div>
                    <MobileNavigation  onConsultation={() => setIsPopupOpen(true)}/>
                </div>
            </div>
        </div>
    </header>
    <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}
